import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
}

export const InviteMoreUsersIcon: React.FC<IProps> = props => {
	const { className } = props;
	return (
		<SvgIcon className={`input-field-enter-icon ${className || ''}`} height={36} width={42}>
			<path
				d='M17.534 35.863c9.626 0 17.43-7.803 17.43-17.43 0-9.626-7.804-17.43-17.43-17.43-9.627 0-17.43 7.804-17.43 17.43 0 9.627 7.803 17.43 17.43 17.43z'
				fill='url(#paint0_linear)'
				opacity='.5'
			/>
			<path
				d='M19.808 14.519l-.314-.112-.017.028h-.018v-.85a1.97 1.97 0 00-.023-.307 3.253 3.253 0 001.115-1.473 3.836 3.836 0 10-6.075 0c.221.589.609 1.1 1.115 1.473a1.97 1.97 0 00-.024.307v.931a7.948 7.948 0 00-5.837 7.67v6.972h15.897v-6.973a7.948 7.948 0 00-5.82-7.666z'
				fill='url(#paint1_linear)'
				opacity='.5'
			/>
			<path d='M17.673 14.346A7.652 7.652 0 0125.326 22v6.715H10.02V22a7.653 7.653 0 017.653-7.653z' fill='#00528C' />
			<rect x='15.643' y='11.849' width='3.748' height='4.685' rx='1.874' fill='#FDA57D' />
			<path opacity='.05' d='M14.343 15.176l1.256 2.694 1.25-1.25-1.25-1.913-1.256.469z' fill='#000' />
			<path
				d='M14.386 15.045l1.255 2.694 1.255-1.255-1.255-1.913-.574.175a1.42 1.42 0 00-.165.062l-.516.237z'
				fill='#fff'
			/>
			<path opacity='.05' d='M20.696 15.045l-1.262 2.825-1.25-1.25 1.285-2.015 1.227.44z' fill='#000' />
			<path
				d='M20.653 14.914l-1.255 2.826-1.255-1.255 1.284-2.015.236.067c.254.073.503.162.746.266l.244.11z'
				fill='#fff'
			/>
			<path d='M16.799 16.39l.698 1.02.738-1.02h-1.436z' fill='#FDA57D' />
			<path opacity='.1' d='M12.897 20.083s-.745 7.404-.264 7.887l.264-7.887z' fill='#000' />
			<path
				opacity='.05'
				d='M17.517 14.122a3.108 3.108 0 001.847-.603 1.874 1.874 0 00-1.85-1.578c-.92.001-1.703.67-1.848 1.578a3.109 3.109 0 001.85.603z'
				fill='#000'
			/>
			<path d='M17.517 13.447a3.692 3.692 0 100-7.385 3.692 3.692 0 000 7.385z' fill='#000' />
			<path d='M17.517 14.035a3.124 3.124 0 100-6.247 3.124 3.124 0 000 6.247z' fill='#FDA57D' />
			<path
				opacity='.05'
				d='M15 7.815l.79.963s3.46.307 3.855-.482c.394-.79-2.279-1.358-2.279-1.358L15 7.814z'
				fill='#000'
			/>
			<path d='M15 7.727l.79.963s3.46.307 3.855-.482c.394-.79-2.279-1.358-2.279-1.358L15 7.727z' fill='#000' />
			<path
				d='M14.386 11.101c.121 0 .22-.176.22-.394 0-.218-.099-.395-.22-.395-.12 0-.219.177-.219.395 0 .218.098.394.22.394z'
				fill='#FDA57D'
			/>
			<path
				d='M41.692 6.813h-6.808V.007H30.97v6.806h-6.808v3.915h6.808v6.806h3.914v-6.806h6.808V6.813z'
				fill='url(#paint2_linear)'
				opacity='.5'
			/>
			<path fill='#00AAE8' d='M31.264 1.319h3.326v14.9h-3.326z' />
			<path d='M40.377 7.108v3.327h-14.9V7.108h14.9z' fill='#00AAE8' />
			<defs>
				<linearGradient
					id='paint0_linear'
					x1='34.964'
					y1='35.863'
					x2='34.964'
					y2='1.003'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#046CB6' />
					<stop offset='1' stopColor='gray' stopOpacity='.1' />
				</linearGradient>
				<linearGradient
					id='paint1_linear'
					x1='9.725'
					y1='29.154'
					x2='25.621'
					y2='29.154'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='gray' stopOpacity='.25' />
					<stop offset='.54' stopColor='gray' stopOpacity='.12' />
					<stop offset='1' stopColor='gray' stopOpacity='.1' />
				</linearGradient>
				<linearGradient id='paint2_linear' x1='41.693' y1='17.534' x2='41.693' y2='.004' gradientUnits='userSpaceOnUse'>
					<stop stopColor='gray' stopOpacity='.25' />
					<stop offset='.54' stopColor='gray' stopOpacity='.12' />
					<stop offset='1' stopColor='gray' stopOpacity='.1' />
				</linearGradient>
			</defs>
		</SvgIcon>
	);
};
